import {AppThunkAction} from '../../../types/redux'

import {
  aFetchBeneficialOwners,
  selectBeneficialOwnersWhereLoaded,
} from '../../../data/beneficial-owners'

export const selectBeneficialOwnerItemsArePending = (state: Record<string, any>): boolean =>
  !selectBeneficialOwnersWhereLoaded(state)

export const aInitializeBeneficialOwnerItems =
  (): AppThunkAction<void> =>
  (dispatch): void => {
    dispatch(aFetchBeneficialOwners())
  }
